import React from 'react';
import { Observable } from 'rxjs';

import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { REFERRAL_VALUES_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

type ReferralProgramValuesData = {
    refereeCredit: number;
    refereeCreditMinimum: number;
    advocateCredit: number;
    advocateCreditMinimum: number;
};

type ReferralProgramValuesState = {
    requestState: string;
    errors: { [key: string]: unknown };
    value: ReferralProgramValuesData | null;
};

const initialValue: ReferralProgramValuesData = {
    refereeCredit: 0,
    refereeCreditMinimum: 0,
    advocateCredit: 0,
    advocateCreditMinimum: 0,
};

type ReferralProgramValuesDataModule = {
    state: ReferralProgramValuesState;
    dataRequest: VoidFunction;
    dataReset: VoidFunction;
    sideEffect$: Observable<unknown>;
    state$: Observable<ReferralProgramValuesState>;
    isLoading: boolean;
    isComplete: boolean;
    errors: { [key: string]: string[] } | {};
    data: ReferralProgramValuesData | {};
    isError: boolean;
};

const useReferralProgramValuesDataModule = () => {
    const dataModule = useDataModule(() =>
        authenticatedJsonFetch(REFERRAL_VALUES_ENDPOINT),
    );

    return dataModule;
};

const providerFactory = (
    Context: React.Context<ReferralProgramValuesDataModule>,
) => {
    const Provider = ({ children }: { children: React.ReactNode }) => {
        const dataModule = useReferralProgramValuesDataModule();
        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };
    return Provider;
};

export const [
    UseReferralProgramValuesDataModuleProvider,
    useReferralProgramValuesContext,
] = createContextProvider(providerFactory);

export const getReferralProgramRefereeCredit = (
    state: ReferralProgramValuesState,
) => {
    if (getData(state)) {
        return getData(state).refereeCredit;
    }

    return initialValue.refereeCredit;
};
export const getReferralProgramAdvocateCredit = (
    state: ReferralProgramValuesState,
) => {
    if (getData(state)) {
        return getData(state).advocateCredit;
    }

    return initialValue.advocateCredit;
};
export const getReferralProgramRefereeCreditMinimum = (
    state: ReferralProgramValuesState,
) => {
    if (getData(state)) {
        return getData(state).refereeCreditMinimum;
    }

    return initialValue.refereeCreditMinimum;
};
